import * as React from 'react';

import { Col, Empty, Form, Input, Row } from 'antd';

import {
  AntdRouterExternalLink,
  PhoneOutlinedIcon,
  PrimitiveNeshanIframe,
} from 'components';
import { usePurchaseValue } from 'context';

type FieldType = Partial<Record<string, string | number>>;

const PurchaseRecipientInfo = () => {
  const { recipientAddress } = usePurchaseValue();

  const { firstName, lastName, phoneNumber, telNumber, city, address } =
    recipientAddress ?? {};
  const { name: cityName, province } = city ?? {};
  const { name: provinceName } = province ?? {};
  const {
    no: addressNO,
    unit: addressUnit,
    postalCode: addressPostalCode,
    content: addressContent,
    lat: addressLat,
    long: addressLong,
  } = address ?? {};

  return (
    <Row>
      <React.Fragment>
        <Col span={24} lg={12} className='lg:pe-3'>
          <Form.Item<FieldType>
            label='نام'
            name='firstName'
            initialValue={firstName}
          >
            <Input readOnly variant='filled' placeholder='فاقد نام' />
          </Form.Item>
        </Col>
        <Col span={24} lg={12} className='lg:ps-3'>
          <Form.Item<FieldType>
            label='نام خانوادگی'
            name='lastName'
            initialValue={lastName}
          >
            <Input readOnly variant='filled' placeholder='فاقد نام خانوادگی' />
          </Form.Item>
        </Col>
      </React.Fragment>
      <React.Fragment>
        <Col span={24} lg={12} className='lg:pe-3'>
          <Form.Item<FieldType>
            label='تلفن همراه'
            name='phoneNumber'
            initialValue={phoneNumber}
          >
            <Input
              readOnly
              variant='filled'
              placeholder='فاقد تلفن همراه'
              suffix={
                phoneNumber ? (
                  <AntdRouterExternalLink href={`tel:${phoneNumber}`}>
                    <PhoneOutlinedIcon className='rotate-90' />
                    <span className='sr-only'>
                      برقراری تماس با تلفن همراه گیرنده
                    </span>
                  </AntdRouterExternalLink>
                ) : null
              }
            />
          </Form.Item>
        </Col>
        <Col span={24} lg={12} className='lg:ps-3'>
          <Form.Item<FieldType>
            label='تلفن ثابت'
            name='telNumber'
            initialValue={telNumber}
          >
            <Input
              readOnly
              variant='filled'
              placeholder='فاقد تلفن ثابت'
              suffix={
                telNumber ? (
                  <AntdRouterExternalLink href={`tel:${telNumber}`}>
                    <PhoneOutlinedIcon className='rotate-90' />
                    <span className='sr-only'>
                      برقراری تماس با تلفن ثابت گیرنده
                    </span>
                  </AntdRouterExternalLink>
                ) : null
              }
            />
          </Form.Item>
        </Col>
      </React.Fragment>
      <React.Fragment>
        <Col span={24} lg={12} className='lg:pe-3'>
          <Form.Item<FieldType>
            label='استان'
            name='provinceName'
            initialValue={provinceName}
          >
            <Input readOnly variant='filled' placeholder='فاقد استان' />
          </Form.Item>
        </Col>
        <Col span={24} lg={12} className='lg:ps-3'>
          <Form.Item<FieldType>
            label='شهر'
            name='cityName'
            initialValue={cityName}
          >
            <Input readOnly variant='filled' placeholder='فاقد شهر' />
          </Form.Item>
        </Col>
      </React.Fragment>
      <React.Fragment>
        <Col span={12} lg={6} className='pe-1.5'>
          <Form.Item<FieldType>
            label='پلاک'
            name='addressNO'
            initialValue={addressNO}
          >
            <Input readOnly variant='filled' placeholder='فاقد پلاک' />
          </Form.Item>
        </Col>
        <Col span={12} lg={6} className='ps-1.5 lg:pe-3'>
          <Form.Item<FieldType>
            label='واحد'
            name='addressUnit'
            initialValue={addressUnit}
          >
            <Input readOnly variant='filled' placeholder='فاقد واحد' />
          </Form.Item>
        </Col>
        <Col span={24} lg={12} className='lg:ps-3'>
          <Form.Item<FieldType>
            label='کد پستی'
            name='addressPostalCode'
            initialValue={addressPostalCode}
          >
            <Input readOnly variant='filled' placeholder='فاقد کد پستی' />
          </Form.Item>
        </Col>
      </React.Fragment>
      <React.Fragment>
        <Col span={24}>
          <Form.Item<FieldType>
            label='جزئیات آدرس'
            name='addressContent'
            initialValue={addressContent}
          >
            <Input.TextArea
              readOnly
              autoSize
              variant='filled'
              placeholder='فاقد جزئیات آدرس'
            />
          </Form.Item>
        </Col>
      </React.Fragment>
      <React.Fragment>
        <Col span={24}>
          <Form.Item<FieldType> label='مشخصات آدرس' name='addressLocation'>
            <div className='grid min-h-96 place-items-center border bg-[--ant-color-fill-alter]'>
              {addressLat && addressLong ? (
                <PrimitiveNeshanIframe lat={addressLat} long={addressLong} />
              ) : (
                <Empty description='فاقد مشخصات آدرس' />
              )}
            </div>
          </Form.Item>
        </Col>
      </React.Fragment>
    </Row>
  );
};

export { PurchaseRecipientInfo };
